"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KilogramSquareMeter = void 0;
var uom_1 = require("uom");
var UnitTimes = require("../unit-times");
var area_1 = require("./area");
/// Moment of inertia
exports.KilogramSquareMeter = UnitTimes.massByArea("KilogramSquareMeter", uom_1.BaseUnits.Kilogram, area_1.SquareMeter);
//# sourceMappingURL=moment-of-inertia.js.map